/**
 * Plain-English wording and list shaping for triggered emails
 * (docs/features/triggered-emails/01_product_brief.md §17 glossary).
 */

import type {
  TriggerCandidate,
  TriggerCandidateState,
  TriggerLeftOutReason,
} from "../data/marketing-types";

export const LEFT_OUT_REASON_LABELS: Record<TriggerLeftOutReason, string> = {
  opted_out: "Opted out of email",
  public_site_shopper: "Can't be emailed (public-site shopper)",
  bounced_before: "Bounced before",
  already_had_it: "Already had this email",
  marked_inactive: "Marked inactive",
  suppressed: "Suppressed from marketing",
  no_email: "No email address",
  mailchimp_rejected: "Mailchimp refused the address",
};

export const CANDIDATE_GROUP_LABELS: Record<TriggerCandidateState, string> = {
  to_send: "To send",
  needs_you: "Needs you",
  left_out: "Left out",
};

export function groupTriggerCandidates(
  candidates: readonly TriggerCandidate[],
): Record<TriggerCandidateState, TriggerCandidate[]> {
  return {
    to_send: candidates.filter((c) => c.state === "to_send"),
    needs_you: candidates.filter((c) => c.state === "needs_you"),
    left_out: candidates.filter((c) => c.state === "left_out"),
  };
}

/** How many emails "Approve and send" will send: the "To send" rows not
 *  removed, plus the "Needs you" rows that have a contact picked. */
export function countToSend(
  candidates: readonly TriggerCandidate[],
  removed: ReadonlySet<string>,
  picked: Readonly<Record<string, string>>,
): number {
  return candidates.filter(
    (c) =>
      (c.state === "to_send" && !removed.has(c.firing_id)) ||
      (c.state === "needs_you" && Boolean(picked[c.firing_id])),
  ).length;
}
